import NotifyController from './session-notification-modal.controller';
import template from './session-notification-modal.html';

class SessionNotificationController {
    constructor($rootScope, $uibModal, $scope) {
        this._$uibModal = $uibModal;
        this._$rootScope = $rootScope;

        $scope.$on('showExpirationDialog', () => {
            if(!this.dialogIsShown) {
                this.openHelpWindow();
            }
        });
    }

    openHelpWindow() {
        this.dialogIsShown = true;
        this._$uibModal.open({
            animation: false,
            template: template,
            controllerAs: '$ctrl',
            size: 'md',
            resolve: {},
            controller: NotifyController,
        }).result.then(()=> {
            this._$rootScope.$broadcast('solverFinished', 'ping');
            this.dialogIsShown = undefined;
        }, () => {
            this.dialogIsShown = undefined;
            this._$rootScope.$broadcast('solverFinished', 'ping');
        });
    }
}


SessionNotificationController.$inject = ['$rootScope', '$uibModal', '$scope'];

export default SessionNotificationController;



// WEBPACK FOOTER //
// ./client/app/common/session-notification/session-notification.controller.js